const industries = [{
    "id": 1169575,
    "name": "Financial Institutions",
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/industries\/financial-institutions.svg",
    "sectors": [{
        "id": 1169572,
        "name": "Asset Management"
    }, {
        "id": 1169573,
        "name": "Banks\/Lending Institutions"
    }, {
        "id": 1169574,
        "name": "Insurance Companies"
    }]
}, {
    "id": 1169550,
    "name": "Professional Services",
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/industries\/professional-services.svg",
    "sectors": [{
        "id": 1169544,
        "name": "Accountants\/Auditors"
    }, {
        "id": 1169548,
        "name": "Insurance Agents"
    }, {
        "id": 1169545,
        "name": "Advertising\/PR Agencies"
    }, {
        "id": 1169546,
        "name": "Architects\/Engineers"
    }, {
        "id": 1169547,
        "name": "Business Consultants"
    }, {
        "id": 1169549,
        "name": "Law Firms"
    }]
}, {
    "id": 1169601,
    "name": "Healthcare",
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/industries\/healthcare.svg",
    "sectors": [{
        "id": 1169598,
        "name": "Hospitals & Healthcare Systems"
    }, {
        "id": 1169599,
        "name": "Long Term Care Facilities"
    }, {
        "id": 1254995,
        "name": "Managed Care"
    }, {
        "id": 1169600,
        "name": "Outpatient Medical"
    }, {
        "id": 1254996,
        "name": "Physician Groups"
    }]
}, {
    "id": 1169571,
    "name": "Technology",
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/industries\/technology.svg",
    "sectors": [{
        "id": 1169567,
        "name": "Computer Software Developers"
    }, {
        "id": 1169568,
        "name": "Hardware Manufacturers"
    }, {
        "id": 1169569,
        "name": "Network Service Providers"
    }, {
        "id": 1169570,
        "name": "Technology Service Providers"
    }]
}, {
    "id": 1169597,
    "name": "Life Sciences",
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/industries\/life-sciences.svg",
    "sectors": [{
        "id": 1169592,
        "name": "Clinical Trials"
    }, {
        "id": 1169593,
        "name": "Dietary Supplements"
    }, {
        "id": 1169594,
        "name": "LS Service Organizations"
    }, {
        "id": 1169595,
        "name": "Medical Devices"
    }, {
        "id": 1169596,
        "name": "Pharmaceutical\/Biotechnology"
    }]
}, {
    "id": 1169539,
    "name": "Cross Industry",
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/industries\/cross-industry.svg",
    "sectors": [{
        "id": 1169536,
        "name": "Clean Technology"
    }, {
        "id": 1169537,
        "name": "Federal Contractors"
    }, {
        "id": 1169538,
        "name": "Private Equity"
    }]
}, {
    "id": 1169566,
    "name": "Other Services",
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/industries\/other-services.svg",
    "sectors": [{
        "id": 1169555,
        "name": "Amusement Parks & Clubs"
    }, {
        "id": 1169556,
        "name": "Aviation"
    }, {
        "id": 1169557,
        "name": "Commercial Real Estate"
    }, {
        "id": 1169558,
        "name": "Construction"
    }, {
        "id": 1169559,
        "name": "Cultural Institutions"
    }, {
        "id": 1169560,
        "name": "Educational Institutions"
    }, {
        "id": 1169561,
        "name": "Hotels"
    }, {
        "id": 1249858,
        "name": "Marine Facilities"
    }, {
        "id": 1169562,
        "name": "Public Entity"
    }, {
        "id": 1169563,
        "name": "Retailers"
    }, {
        "id": 1169564,
        "name": "Transportation"
    }, {
        "id": 1169565,
        "name": "Wholesalers"
    }]
}, {
    "id": 1169591,
    "name": "Manufacturing & Processing",
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/industries\/manufacturing-processing.svg",
    "sectors": [{
        "id": 1169580,
        "name": "Food"
    }, {
        "id": 1169588,
        "name": "Textiles"
    }, {
        "id": 1169579,
        "name": "Fabricated Products"
    }, {
        "id": 1169590,
        "name": "Wood & Furniture"
    }, {
        "id": 1169585,
        "name": "Paper Products"
    }, {
        "id": 1169586,
        "name": "Printing & Publishing"
    }, {
        "id": 1169577,
        "name": "Chemical & Allied"
    }, {
        "id": 1169587,
        "name": "Rubber & Plastics"
    }, {
        "id": 1169582,
        "name": "Leather, Stone & Glass"
    }, {
        "id": 1169584,
        "name": "Metal Workers"
    }, {
        "id": 1169583,
        "name": "Machinery"
    }, {
        "id": 1169578,
        "name": "Electrical Equipment"
    }, {
        "id": 1169576,
        "name": "Auto Parts"
    }, {
        "id": 1169589,
        "name": "Transport Equip (non Auto)"
    }, {
        "id": 1169581,
        "name": "Instruments"
    }]
}, {
    "id": 1169554,
    "name": "Energy",
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/industries\/energy.svg",
    "sectors": [{
        "id": 1169551,
        "name": "Mining"
    }, {
        "id": 1169552,
        "name": "Petroleum"
    }, {
        "id": 1169553,
        "name": "Power"
    }]
}, {
    "id": 1169543,
    "name": "Media & Entertainment",
    "icon": "https:\/\/appetiteapp.chubb.com\/img\/industries\/media-entertainment.svg",
    "sectors": [{
        "id": 1169540,
        "name": "Broadcasters"
    }, {
        "id": 1169541,
        "name": "Film Production"
    }, {
        "id": 1169542,
        "name": "Theater Production"
    }]
}];

export default industries;



// WEBPACK FOOTER //
// ./src/data/industries.js